import { Box, Grid, IconButton, Typography } from '@mui/material';
import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import InputText from '../../../common/Form';
import QRCode from "react-qr-code";
import { isEmpty } from 'lodash';
import { DownloadRounded, PrintRounded } from '@mui/icons-material';
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';

class GenerateQrCode extends Component {
    state = { 
        infos: "",
    }
    // componentDidMount = () => {
    //     let infos = ""
    //     if (!isEmpty(this.props.equipement)) {
    //         infos = `Aquisition : ${new Date(this.props.equipement.equipement_date).toLocaleDateString("fr-FR")}
    //             ID : ${this.props.equipement.equipement_id}
    //             Nom : ${this.props.equipement.equipement_name}
    //         `
    //     }        
    // }

    onImageDownload = async () => {
        const canvas = await html2canvas(document.getElementById("section-to-print"));
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, `${this.props.equipement.equipement_ref}.png`, 'image/png');
    };
    // onImageDownload = () => {
    //     const svg = document.getElementById("section-to-print");
    //     const svgData = new XMLSerializer().serializeToString(svg);
    //     const canvas = document.createElement("canvas");
    //     const ctx = canvas.getContext("2d");
    //     const img = new Image();
    //     img.onload = () => {
    //         canvas.width = img.width;
    //         canvas.height = img.height;
    //         ctx.drawImage(img, 0, 0);
    //         const pngFile = canvas.toDataURL("image/png");
    //         const downloadLink = document.createElement("a");
    //         downloadLink.download = "section-to-print";
    //         downloadLink.href = `${pngFile}`;
    //         downloadLink.click();
    //     };
    //     img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    // };
    render() {
        return (
            <Dialog
                title={this.props.equipement.equipement_name}
                close={this.props.handleClose}
                secondaryAction={
                    <IconButton
                        aria-label="download"
                        // className={classes.closeButton}
                        // onClick={() => console.log("HELLOOOOOO")}
                        onClick={this.onImageDownload}
                        size="large"
                    >
                        <DownloadRounded />
                    </IconButton>
                }
                appBar
                // maxWidth="md"
            >
                <Box p={1} id="section-to-print">
                    <Box style={{ border: "1px solid #f0f0f0", borderRadius: "5px", textAlign: "center"}}>
                        {this.props.equipement &&
                            <Box style={{ alignItems: "center", justifyContent: "center"}}>
                            {/* <Box style={{ display: "flex", alignItems: "center", justifyContent: "center"}}> */}
                                <Box p={1} >
                                    <Typography variant="h4" color="error">{this.props.equipement.equipement_unique_ref}</Typography>
                                </Box>
                                <Box  p={1}>
                                    <QRCode
                                        size={256}
                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                        value={`https://myjoulebox.com:5000/equipement/${this.props.equipement.equipement_id}`}
                                        viewBox={`0 0 256 256`}
                                        id="QRCode"
                                    />
                                </Box>
                                <Box p={1} >
                                    <Typography variant="h3">{this.props.equipement.equipement_ref}</Typography>
                                </Box>
                            </Box>
                            // <Grid container spacing={1}>
                            //     <Grid item xs={9}>
                            //         <QRCode
                            //             size={256}
                            //             style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                            //             value={`https://myjoulebox.com:5000/equipement/${this.props.equipement.equipement_id}`}
                            //             viewBox={`0 0 256 256`}
                            //             id="QRCode"
                            //         />
                            //     </Grid>
                            //     <Grid item xs={3} id="print-qr-ref" >
                            //         <Typography variant="h3">{this.props.equipement.equipement_ref}</Typography>
                            //     </Grid>
                            // </Grid>
                            
                        }
                    </Box>
                </Box>
            </Dialog>
        );
    }
}

export default GenerateQrCode;